import PropTypes from 'prop-types';
import {Tab, TabsNavigation} from '@/components/atoms';
import {PERFECT_STORE_PREVIEW_TABS} from './perfectStorePreviewTabsConstants';

const UPDATE_STORE_VISITS_DISABLED_TOOLTIP =
  'Update Store Visits is unavailable for the current status.';

const PerfectStorePreviewTabs = ({
  activeTabIndex,
  onTabChange,
  requirementsContent,
  updateStoreVisitsContent,
  isUpdateStoreVisitsTabEnabled = true
}) => (
  <div
    className='perfect-store-preview-tabs w-full'
    data-testid='perfect-store-preview-tabs'>
    <TabsNavigation
      handleSetActiveTab={onTabChange}
      activeTabIndex={activeTabIndex}
      className='mb-5'>
      <Tab label='Requirements' isDark />
      <Tab
        label='Update Store Visits'
        isDark
        disabled={!isUpdateStoreVisitsTabEnabled}
        title={
          isUpdateStoreVisitsTabEnabled
            ? undefined
            : UPDATE_STORE_VISITS_DISABLED_TOOLTIP
        }
      />
    </TabsNavigation>
    {activeTabIndex === PERFECT_STORE_PREVIEW_TABS.REQUIREMENTS
      ? requirementsContent
      : null}
    {activeTabIndex === PERFECT_STORE_PREVIEW_TABS.UPDATE_STORE_VISITS ? (
      <div
        data-testid='perfect-store-update-store-visits-tab'
        className='w-full'>
        {updateStoreVisitsContent || null}
      </div>
    ) : null}
  </div>
);

PerfectStorePreviewTabs.propTypes = {
  activeTabIndex: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
  requirementsContent: PropTypes.node,
  updateStoreVisitsContent: PropTypes.node,
  isUpdateStoreVisitsTabEnabled: PropTypes.bool
};

export default PerfectStorePreviewTabs;
